/**
 * Сгенерировать объект API фильтра
 */
export const genFieldFilter = <
	Model extends Api.Ext.Schemas['Model'],
	FieldName extends Api.Field.Name<Model> = Api.Field.Name<Model>
>(
	name: FieldName,
	operator: Api.Field.Filter<Model, FieldName>['operator'],
	values: Api.Field.Filter<Model, FieldName>['values'],
): Api.Field.Filter<Model, FieldName> => {
	return {
		name,
		operator,
		values,
	};
};

/**
 * Сгенерировать объект сортировки
 */
export const genFieldOrder = <
	Model extends Api.Ext.Schemas['Model'],
	FieldName extends Api.Field.Name<Model> = Api.Field.Name<Model>
>(
	name: FieldName,
	direction: Api.Field.Order<Model, FieldName>['direction'],
	orderValues?: Api.Field.Order<Model, FieldName>['orderValues'],
	operator?: Api.Field.Order<Model, FieldName>['operator'],
	values?: Api.Field.Order<Model, FieldName>['values'],
): Api.Field.Order<Model, FieldName> => {
	return {
		name,
		direction,
		orderValues,
		operator,
		values,
	};
};
